'use strict'

import React from 'react'

class MissingValueComponent extends React.Component {
    state = {
        color: this.props.Dyn.plotUtil.kCaseMissingValueColor,
    };

    handleClick = (e) => {
        let mediator = this.props.Dyn.mediator;
        console.log('publish message for selection of missing values.');
        var attrID = this.props.attributeObj.id,
            categoryName = this.props.Dyn.dataUtil.kMissingValue,
            isNumericInterval = false,
            data = { "attributeID":attrID, "category":categoryName, isNumericInterval:isNumericInterval };
        // select the cases with the given category for this attribute
        mediator.publish( "records:casesSelectedByCategory", data );
    };
    // Get category color to display along with the checklist of category
    componentDidMount = () => {

    };

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc( str );
    };

    render = () => {
        return (
            <div className={"tde-row tde-missing-value-component tde-mt-3 tde-d-flex tde-flex-items-center"  + (this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3')}>
                <div className="tde-s1 tde-font-weight-bold tde-attr-name">{this.getLoc('Missing')}</div>
                <div className="tde-input-legend tde-ml-2 tde-mb-0">
                    <button
                        className="tde-legend-color tde-mx-2"
                        style={{
                            cursor: 'pointer',
                            background: this.state.color,
                            width: '24px',
                            height: '24px',
                            border: '2px solid #000',
                            borderRadius: '100%',
                            margin: 0,
                            padding: 0
                        }}
                        onClick={this.handleClick}
                        role="button"
                        aria-label={`${this.getLoc('Select')} ${this.props.attributeObj.statsPreFilter.missingCaseCount} ${this.props.attributeObj.statsPreFilter.missingCaseCount > 1 ? this.getLoc('missing cases') : this.getLoc('missing case')}`}
                        title={`${this.getLoc('Select')} ${this.props.attributeObj.statsPreFilter.missingCaseCount} ${this.props.attributeObj.statsPreFilter.missingCaseCount > 1 ? this.getLoc('missing cases') : this.getLoc('missing case')}`}
                    />
                    <span className="tde-ml-1" aria-hidden="true">
                        { this.props.attributeObj.statsPreFilter.missingCaseCount } { this.props.attributeObj.statsPreFilter.missingCaseCount > 1 ? this.getLoc('cases') : this.getLoc('case') }
                    </span>
                </div>
            </div>
        )
    };
}

export default MissingValueComponent
